import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MdbFormsModule } from 'mdb-angular-ui-kit/forms';

import { MdbModalRef } from 'mdb-angular-ui-kit/modal';
import { MdbSelectModule } from 'mdb-angular-ui-kit/select';
import { Utente } from 'src/app/models/rbac/Utente';
import { UtenteService } from 'src/app/services/utente.service';

@Component({
  selector: 'app-nuovo-utente',
  standalone: true,
  templateUrl: './nuovo-utente.component.html',
  styleUrls: ['./nuovo-utente.component.scss'],
  imports: [CommonModule, MdbFormsModule, MdbSelectModule,
    ReactiveFormsModule
  ]
})
export class NuovoUtenteComponent implements OnInit {

  formUtente = new FormGroup({
    nome: new FormControl(''),
    cognome: new FormControl(''),
    cf: new FormControl(''),
    email: new FormControl(''),
    ruolo: new FormControl(''),
    abilitato: new FormControl(''),
  })
  titolo: string = ''
  ruoli: any[] = []
  utente: Utente = new Utente()

  constructor(public modalRef: MdbModalRef<NuovoUtenteComponent>,
    private servUtenti: UtenteService) { }

  ngOnInit(): void {
    this.servUtenti.getRuoli().subscribe((data: any) => {
      this.ruoli = data['data']
      this.formUtente.patchValue({
        nome: this.utente.getNome(),
        cognome: this.utente.getCognome(),
        email: this.utente.getEmail(),
        ruolo: this.utente.getIDTipoUt().toString(),
        abilitato: this.utente.getConfirmed() ? '1' : '0'
      })
    })
  }

  close() {
    let u = this.formUtente.value
    this.utente.setUtente({
      email: u.email,
      nome: u.nome,
      cognome: u.cognome,
      confirmed: u.abilitato == '1',
    })
    if (typeof u.cf === 'string') {
      let ruolo = this.ruoli.find(r => r.id == u.ruolo)
      this.utente.tipoUtente.setTipoUtente(ruolo.id, ruolo.ruolo, ruolo.gerarchia)
    }

    this.modalRef.close(this.utente)
  }

}
